<template>
  <a-modal
    v-bind="attrs"
    :confirm-loading="confirmLoading"
    :centered="true"
    title="分享"
    :footer="null"
    :zIndex="1009"
  >
    <div class="share-modal">
      <div class="bg-color flex-col ht200">
        <img src="@/assets/images/aiDAM/shareFolder.png" class="wd80" />
        <div class="fs-14 mt-10">共{{ store.shareFolderData?.ids.length }}项访问内容</div>
      </div>
      <div class="padding-24">
        <div class="flex-b mb-10">
          <div class="fs-14">选择有效期</div>
          <div>
            <a-select
              v-model:value="states.formState.expirationDay"
              :options="options1"
              :disabled="!!link.length"
              size="small"
            ></a-select>
          </div>
        </div>
        <div class="flex-b mb-10">
          <div class="fs-14">访问权限</div>
          <div>
            <a-select
              v-model:value="states.formState.shareType"
              :options="options2"
              :disabled="!!link.length"
              size="small"
            ></a-select>
          </div>
        </div>
        <div class="flex-b mb-10">
          <div class="fs-14">加密分享</div>
          <div>
            <a-switch
              v-model:checked="states.formState.isEncrypt"
              :checkedValue="true"
              :unCheckedValue="false"
              :disabled="!!link.length"
              @change="states.formState.password = ''"
            />
          </div>
        </div>
        <!-- <div class="flex-b mb-10">
          <div class="fs-14">是否对外可见</div>
          <div>
            <a-switch
              v-model:checked="states.formState.teamStatus"
              :checkedValue="0"
              :unCheckedValue="1"
              :disabled="!!link.length"
            />
          </div>
        </div> -->
        <div v-show="states.formState.isEncrypt">
          <div class="fs-14 mb-10">请输入访问密码</div>
          <div>
            <a-input
              v-model:value="states.formState.password"
              placeholder="请输入4位数密码仅支持数字及字母"
              :disabled="!!link.length"
            />
          </div>
        </div>
        <div class="flex-b mb-10">
          <a-input class="mt-10" v-model:value="link" readonly="" v-if="link.length">
            <template #suffix>
              <CopyOutlined class="cursor-p" @click="copy" />
            </template>
          </a-input>
        </div>
      </div>
      <div class="flex pr-28" v-show="!link.length">
        <a-button type="primary" @click="handleOk"> 创建分享链接 </a-button>
      </div>
      <div class="flex-b pl-28 pr-28" v-show="link.length">
        <div v-if="states.shareInfo?.expirationDay?.length">
          {{ states.shareInfo?.expirationDay }}天后到期
        </div>
        <div v-else>永久有效</div>
        <div>
          <a-button type="primary" ghost @click="cancel"> 取消分享 </a-button>
          <a-button class="ml-10" type="primary" @click="copy"> 复制链接 </a-button>
        </div>
      </div>
      <div class="text share-header fs-12 mt-40">
        响应净网行动，严禁传播色情等违法内容，如发现账号封禁处理。
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import {
  Modal as AModal,
  Select as ASelect,
  Switch as ASwitch,
  Input as AInput,
  Button as AButton,
  message
} from 'ant-design-vue'
import { ref, useAttrs, watch, reactive } from 'vue'
import { aigcStore } from '@/store/aigcStore'
import { cloneDeep } from 'lodash'
import { CopyOutlined } from '@ant-design/icons-vue'
import { createShareLink, deleteShareLink } from '@/service/api/aiDam'

const initForm = {
  expirationDay: 30,
  shareType: 2,
  isEncrypt: false,
  teamStatus: 0,
  password: ''
}
const emits = defineEmits(['asyncSuccess'])

const store = aigcStore()
const attrs = useAttrs()
const confirmLoading = ref(false)
const link = ref('')
const options1 = ref([
  {
    label: '30天内有效',
    value: 30
  },
  {
    label: '7天内有效',
    value: 7
  },
  {
    label: '永久有效',
    value: ''
  }
])
const options2 = ref([
  {
    label: '可下载可转存',
    value: 2
  },
  {
    label: '仅查看',
    value: 1
  }
])
const states = reactive({
  formState: cloneDeep(initForm),
  shareInfo: null
})

const handleOk = () => {
  const regex = /^[a-zA-Z0-9]{4}$/
  if (states.formState.isEncrypt && !states.formState.password.length)
    return message.error('请输入访问密码')
  if (states.formState.isEncrypt && !regex.test(states.formState.password))
    return message.error('密码格式错误')
  confirmLoading.value = true
  createShareLink({
    folderIds: store.shareFolderData.ids.filter((i) => i.itemType == 'folder').map((i) => i.id),
    fileIds: store.shareFolderData.ids.filter((i) => i.itemType == 'case').map((i) => i.id),
    shareType: states.formState.shareType,
    teamStatus: states.formState.teamStatus,
    isEncrypt: states.formState.isEncrypt,
    password: states.formState.password,
    expirationDay: states.formState.expirationDay
  }).then((res) => {
    if (res?.data) {
      states.shareInfo = res.data
      message.success('创建成功')
      link.value = process.env.VUE_APP_aiDAM_H5_URL + res.data.shareCode
      emits('asyncSuccess', link.value)
    }
    confirmLoading.value = false
  })
}
const cancel = () => {
  deleteShareLink({
    ids: [states.shareInfo.id]
  }).then((res) => {
    if (res.data) {
      link.value = ''
      states.shareInfo = null
      message.success('取消成功')
    }
  })
}
const copy = () => {
  navigator.clipboard.writeText(link.value)
  message.success('复制成功')
}
watch(
  () => attrs.open,
  (val) => {
    confirmLoading.value = false
    if (val) {
      states.shareInfo = null
      link.value = ''
      states.formState = cloneDeep(initForm)
      console.log(store.shareFolderData)
    }
  }
)
</script>

<style lang="less" scoped>
.bg-color {
  background: linear-gradient(0deg, #dddffc 0%, #fcfcff 104%, #fcfcff 106%);
}
.text {
  color: #999999;
  text-align: center;
}
.share-header {
  padding: 8px 16px;
  background: #eeeff9;
  border-radius: 0 0 8px 8px;
}
.share-modal {
  margin-left: -24px;
  margin-right: -24px;
  margin-bottom: -20px;
}
</style>
